import { FC, useMemo } from "react";
import { Button, HStack, Icon, Skeleton, Stack, Text, useToast } from "@chakra-ui/react";

import { ICard } from "../../../../api/cards/types.ts";
import { useGetProfileQuery } from "../../../../api/profile";
import { CopyIcon, EarthIcon, MapPointIcon } from "../../../icons";

interface Props {
  list: { cards: ICard[]; sbp: ICard[] };
}

export const ElecsnetInfo: FC<Props> = ({ list }) => {
  const toast = useToast();
  const { data: profile, isPending: isProfilePending } = useGetProfileQuery();

  const hasPaidPaymentMethod: boolean = useMemo(() => {
    return [...list.cards, ...list.sbp].some(card => card.terminalType === "PAID");
  }, [list]);

  const contractNumber = profile?.contractNumber?.trim() ?? "-";
  const isCopyEnabled = !!profile?.contractNumber?.trim();

  const onCopy = async () => {
    await navigator.clipboard.writeText(profile?.contractNumber || "");

    toast({
      id: "text-copied",
      description: "Скопировано",
    });
  };

  if (!hasPaidPaymentMethod) {
    return null;
  }

  return (
    <Stack mb="11px" spacing="0">
      <Text mb="4px" fontSize="14px">Можно оплатить без комиссии через Элекснет</Text>

      <Stack px="20px" py="10px" mb="5px" spacing="4px" bg="white" borderRadius="12px">
        <Text fontSize="12px" lineHeight="16px" letterSpacing="1%">Номер договора</Text>

        {isProfilePending
          ? <Skeleton h="20px" />
          : (
            <HStack spacing="5px">
              <Text variant="brand" mb="0px">{contractNumber}</Text>

              {isCopyEnabled && (
                <Button minW="20px" h="20px" p="0" colorScheme="transparent" onClick={onCopy}>
                  <CopyIcon />
                </Button>
              )}
            </HStack>
            )}
      </Stack>

      <HStack spacing="4px">
        <HStack
          as="a"
          href="https://elecsnet.ru/payments/"
          target="_blank"
          rel="noopener noreferrer"
          flex="1"
          spacing="6px"
          justifyContent="center"
          py="6px"
          bg="white"
          borderRadius="8px"
        >
          <Icon as={EarthIcon} boxSize="14px" />
          <Text fontSize="12px">Оплатить онлайн</Text>
        </HStack>

        <HStack
          as="a"
          href="https://elecsnet.ru/terminals/"
          target="_blank"
          rel="noopener noreferrer"
          flex="1"
          spacing="6px"
          justifyContent="center"
          py="6px"
          bg="white"
          borderRadius="8px"
        >
          <Icon as={MapPointIcon} boxSize="14px" />
          <Text fontSize="12px">Терминал рядом</Text>
        </HStack>
      </HStack>
    </Stack>
  );
};
